import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  AdminManagedLink,
  ManagedLinkCreatePayload,
  ManagedLinkHistoryResponse,
  ManagedLinkLifecyclePayload,
  ManagedLinkListFilters,
  ManagedLinksPaginatedResponse,
  ManagedLinksOverview,
  ManagedLinkUpdatePayload,
} from "~/types/admin/managedLinks";

class AdminManagedLinksModule extends HttpFactory {
  async getOverview(): Promise<ManagedLinksOverview> {
    return await this.get(`${ENDPOINTS.ADMIN.MANAGED_LINKS}overview/`);
  }

  async getLinks(
    filters: ManagedLinkListFilters = {},
  ): Promise<ManagedLinksPaginatedResponse<AdminManagedLink>> {
    return await this.get(ENDPOINTS.ADMIN.MANAGED_LINKS, filters);
  }

  async getLink(linkId: string): Promise<AdminManagedLink> {
    return await this.get(
      `${ENDPOINTS.ADMIN.MANAGED_LINKS}${encodeURIComponent(linkId)}/`,
    );
  }

  async createLink(
    payload: ManagedLinkCreatePayload,
  ): Promise<AdminManagedLink> {
    return await this.post(ENDPOINTS.ADMIN.MANAGED_LINKS, payload);
  }

  async updateLink(
    linkId: string,
    payload: ManagedLinkUpdatePayload,
  ): Promise<AdminManagedLink> {
    return await this.patch(
      `${ENDPOINTS.ADMIN.MANAGED_LINKS}${encodeURIComponent(linkId)}/`,
      payload,
    );
  }

  async activateLink(
    linkId: string,
    payload: ManagedLinkLifecyclePayload,
  ): Promise<AdminManagedLink> {
    return await this.post(
      `${ENDPOINTS.ADMIN.MANAGED_LINKS}${encodeURIComponent(linkId)}/activate/`,
      payload,
    );
  }

  async deactivateLink(
    linkId: string,
    payload: ManagedLinkLifecyclePayload,
  ): Promise<AdminManagedLink> {
    return await this.post(
      `${ENDPOINTS.ADMIN.MANAGED_LINKS}${encodeURIComponent(linkId)}/deactivate/`,
      payload,
    );
  }

  async getHistory(
    linkId: string,
    filters: Pick<ManagedLinkListFilters, "page" | "pageSize"> = {},
  ): Promise<ManagedLinkHistoryResponse> {
    return await this.get(
      `${ENDPOINTS.ADMIN.MANAGED_LINKS}${encodeURIComponent(linkId)}/history/`,
      filters,
    );
  }
}

export default AdminManagedLinksModule;
